import { menuRoutes } from 'features/menu';
import { firebase } from 'utils';

import { history } from 'utils';
import * as TYPES from './types';

export const signIn = (authToken: string, user: firebase.UserInfo) => {
  const response = {
    authToken,
    user,
  };

  return {
    type: TYPES.AUTH_USER,
    payload: response,
  };
};

export const signingIn = () => {
  return {
    type: TYPES.SIGNING_IN,
  };
};

export const signOut = (): TYPES.ActionType => {
  firebase.auth().signOut();
  history.push(menuRoutes.ARTISTAS);
  return {
    type: TYPES.SIGN_OUT,
    payload: {},
  };
};

export const signInError = (errorMessage: string) => {
  return {
    type: TYPES.AUTH_ERROR,
    payload: { errorMessage },
  };
};
